<template>
  <zm-button
    data-testid="checkout-button-476"
    :data-url='targetUrl'
    data-cta-type='1'
    size='large'
    plain
    round
    icon='zm-icon-download-alt-thin'
    class='opc-succezz_download-action'
    @click='handleDownload'>
    {{ $t('billing.success.confirmation.download_zoom') }}
  </zm-button>
</template>
<script>
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';

export default {
  data() {
    return {
      jumpUrl: '/support/download',
    }
  },
  computed: {
    targetUrl() {
      return getEmailCTAsTrackingUrl(this.jumpUrl, { utmContent: UTM_CONTENT_CODE.downloadZoom });
    }
  },
  methods: {
    handleDownload() {
      this.$tracking.buyInteraction('purchase confirmation', 'download zoom');
      window.open(this.jumpUrl, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.opc-succezz_download-action {
  &.zm-button--plain:not(.is-ghost) {
    border: 1px solid #0C5CFF;
    padding-bottom: 7px;
    padding-top: 7px;
  }

  /deep/ i {
    color: #0C5CFF;
  }

  /deep/.zm-button__slot {
    color: #0C5CFF;
  }
}
</style>
